import React, { Component } from 'react';
import Spread from './Spread';
import Page from './Page';
import IssueIndex from './IssueIndex';
import {IssueStyle} from './Style.js'

const containerStyle = {
   width: '100%',
	height: '100%',
	position: 'relative'
}

// let issue = {
// 	title: 'Gazpress',
// 	description: 'Magazyn Pracowników Polskiej Spółki Gazownictwa',
// 	issueNumber: 'Grudzień nr.5 (26) 2016',
// 	pageSize: {
// 		width: 1343,
// 		height: 1899
// 	},
// 	thumbnailSize: {
// 		width: 71,
// 		height: 100
// 	},
//    pages: [
//       {name: 'Okładka', img: 'issue/emisja_1.jpg', thumbnail: 'issue/thumbnail/emisja_1.jpg'}
//    ]
// }
// var pages = [ ...Array(58).keys() ];
// pages.map((el,i) => {
// 	issue.pages.push({name: `page ${i+2}`, img: `issue/emisja_${i+2}.jpg`, thumbnail: `issue/thumbnail/emisja_${i+2}.jpg`});
// 	return i;
// });
// issue.pages.push({name: 'Tylna okładka', img: 'issue/emisja_60.jpg', thumbnail: 'issue/thumbnail/emisja_60.jpg'});

export default class Issue extends Component {
	spreads = [];

	constructor(props){
		super(props);
		this.state = {
			issue: null,
			issues: null,			
			spreadIndex: 0,
			bottomMenuOpen: true,
			issueIndexOpen: false,
			animateSpreadMove: true,
			archiveOpen: false,
		}
		this.loadIndex();
	}

	loadIndex(){
		fetch('./publication.json').then((response) => {
			if(response.status == 200)
				return response.json();
		})
		.then((jsonResponse) => {
			const locationHash = window.location.hash;
			const regIssue = /(?:issue=)([0-9]+)/g;
			const regSpread = /(?:spread=)([0-9]+)/g;
			const issueIndex = [...locationHash.matchAll(regIssue)].length > 0 ? parseInt([...locationHash.matchAll(regIssue)][0][1]) : 0;
			const spreadIndex = [...locationHash.matchAll(regSpread)].length > 0 ? parseInt([...locationHash.matchAll(regSpread)][0][1]) : 0;
			const {issues, title} = jsonResponse;
			const issue = issues[ issueIndex ? issueIndex : issues.length-1 ];
			this.setState({issue, issues, spreadIndex, issueIndex});
		})
		.catch((publicationFetchError) => console.log({publicationFetchError}));
	}

	componentDidMount(){
		document.addEventListener("keydown", this.handleKeyDown.bind(this));
	}

	componentWillUnmount() {
		document.removeEventListener("keydown", this.handleKeyDown);
	}

	handleKeyDown(e){
		const {keyCode} = e;
		console.log({keyCode})
		switch(keyCode){
			case 27:  
				this.zoomOutSpread();
				break;
			case 320:  
				this.zoomInSpread();
				break;
			default:
			break;
		}
	}

	getBottomMargin() {
		const {bottomMenuOpen, issueIndexOpen} = this.state;
		const {bottomMenuHeight, issueIndexHeight} = IssueStyle;

		let margin = 0;
		
		if(bottomMenuOpen)
			margin += bottomMenuHeight;
		
		if(issueIndexOpen)
			margin += issueIndexHeight

		return margin;
	}

	getSpreads(){
		const {issue} = this.state;
		const length = issue.pages.length;
		let spreads = [];

		spreads[0] = [issue.pages[0]];
		for(let i=1; i<length-1; i+=2)
		{
			spreads.push([issue.pages[i], issue.pages[i+1]]);
		}
		spreads.push([issue.pages[length-1]]);
		return spreads;
	}

	nextSpread(){
		const {spreadIndex, issue} = this.state;
		this.zoomOutSpread();

		if((spreadIndex) < issue.pages.length/2)
		{
			this.setState({spreadIndex: spreadIndex + 1})
			this.updateHash(spreadIndex + 1);
		}
	}

	prevSpread(){
		const {spreadIndex} = this.state;
		this.zoomOutSpread();

		if(spreadIndex - 1 >= 0)
		{
			this.setState({spreadIndex: spreadIndex - 1})
			this.updateHash(spreadIndex - 1);
		}
	}

	goToSpread(newSpreadIndex){
		const {spreadIndex} = this.state;
		const animateSpreadMove = Math.abs(newSpreadIndex - spreadIndex) <= 1;
		this.setState({spreadIndex: newSpreadIndex, animateSpreadMove}, () => {
			this.setState({animateSpreadMove: true});
			this.updateHash(newSpreadIndex);
		});
	}

	onDoubleClick(e){
		const {clientX, clientY} = e;

		this.zoomInSpread({clientX,clientY});
	}

	updateHash(spreadIndex){
		const {issueIndex} = this.state;
		window.location.hash = `issue=${issueIndex},spread=${spreadIndex}`;
	}

	zoomInSpreadWithReset(){
		const {spreadIndex} = this.state;
		this.spreads[spreadIndex].resetCoords();
		this.spreads[spreadIndex].setZoomAnimation(true);
		this.spreads[spreadIndex].zoom();
	}

	zoomInSpread(coords = null){
		const {spreadIndex} = this.state;
		this.spreads[spreadIndex].setZoomAnimation(true);
		this.spreads[spreadIndex].zoom(coords);
	}

	zoomOutSpread(){
		const {spreadIndex} = this.state;
		this.spreads[spreadIndex].setZoomAnimation(true);
		this.spreads[spreadIndex].zoomOut();
	}

	getIssueStyle(){
		const {bottomMenuOpen} = this.state;
		const {bottomMenuHeight} = IssueStyle;
		return {
			bottom: bottomMenuOpen ? bottomMenuHeight : 0
		}
	}

	toggleArchive(){
		const {archiveOpen} = this.state;
		this.setState({archiveOpen: !archiveOpen})
	}

	renderArchive(){
		const {issues, issue} = this.state;		
		return <div className="archive">
			<div className="archiveWrap">
				<h2>Archiwum</h2>
				<ul>
					{issues.map((mapIssue, i) => <li key={`issue=${i}`} className={mapIssue.issueNumber === issue.issueNumber ? 'selected' : ''}>
						<a href={`#issue=${i}`} onClick={() => this.selectIssue(mapIssue)}>{mapIssue.issueNumber}</a>
					</li>)}
				</ul>
			</div>
		</div>
	}

	selectIssue(issue){
		this.setState({issue: null}, () => this.setState({issue, spreadIndex: 0}));
	}

	renderPreloader(){
		return <div className="preloader">Wczytywanie</div>
	}

   render() {
		const {issue} = this.state;
		if(!issue)
			return this.renderPreloader();

		const spreads = this.getSpreads();
		const {spreadIndex, bottomMenuOpen, issueIndexOpen, animateSpreadMove, archiveOpen} = this.state;
		const {pageSize, title, issueNumber} = issue;
		const {bottomMenuHeight} = IssueStyle;
		const bottomMargin = this.getBottomMargin();
		const issueStyle = this.getIssueStyle();
		const pagesCount = issue.pages.length;
		const currentPagesCount = spreads.slice(-(spreadIndex+1)).reduce((sum, el) => sum + el.length ,0)
		const currentPages = currentPagesCount > 1 ? (currentPagesCount < pagesCount ? `${currentPagesCount-1} - ${currentPagesCount}` : currentPagesCount) : currentPagesCount;
		// const spreadCount = (pagesCount/2) + 1;
      return (
         <div style={containerStyle}>
				<button className={'issueControls left'} style={{top: `calc((50% - ${bottomMargin}px) + 20px)`}} onClick={this.prevSpread.bind(this)} >&lt;</button>
				<button className={'issueControls right'} style={{top: `calc((50% - ${bottomMargin}px) + 20px)`}} onClick={this.nextSpread.bind(this)} >&gt;</button>
				{issueIndexOpen ? <IssueIndex onChangeSpreadIndex={this.goToSpread.bind(this)} spreads={spreads} issue={issue} spreadIndex={spreadIndex} /> : null }
				{archiveOpen ? this.renderArchive() : null}
				<div className={'footer'} style={{height: bottomMenuHeight}}>
					<div className={'footer-left'}>
						<button onClick={this.toggleArchive.bind(this)}className={'library-button'}><i className={"fas fa-archive fa-lg"}></i></button>
						<h1>{title}</h1> | 
						<h2>&nbsp;{issueNumber}</h2>
					</div>
					<div className={'footer-center'}>
						<p>{currentPages} / {pagesCount}</p>
					</div>
					<div className={'footer-right'}>
						<button onClick={() => this.zoomInSpreadWithReset()}><i className="fas fa-search-plus fa-lg"></i></button>
						<button onClick={this.zoomOutSpread.bind(this)}><i className="fas fa-search-minus fa-lg"></i></button>

						<button onClick={() => this.setState({issueIndexOpen: !issueIndexOpen})}><i className="fas fa-th fa-lg"></i></button>
						{issue.pdf ? <a href={issue.pdf} target="_blank"><i className="fas fa-file-download fa-lg"></i></a> : null}
					</div>
				</div>

         	<div id="issue" className="issue" style={issueStyle} onDoubleClick={this.onDoubleClick.bind(this)}>
					{spreads.map((spread, si) => {
						const spreadTransform = `translateX(${(si-spreadIndex)*100}%)`
						const visible = Math.abs(si - spreadIndex) < 2;
						const spreadStyle = {
							transform: spreadTransform,
							display: visible ? 'block' : 'none',
							transition: animateSpreadMove ? 'transform 360ms cubic-bezier(0.320, 0.010, 0.000, 1.005)' : 'none'
						};
						
						if(!visible)
							return null;

						return (<Spread pageSize={pageSize} visible={visible} index={si} ref={(ref) => this.spreads[si] = ref} bottomMenuOpen={bottomMenuOpen} issueIndexOpen={issueIndexOpen} single={spread.length === 1} className={'spread'} style={spreadStyle} key={`spread-${si}`}>
							{spread.map((page, pi) => {
								const position = spread.length > 1 ? (pi%2 === 0 ? 'left' : 'right') : 'center';
								return <Page pageSize={pageSize} position={position} page={page} key={`page-${pi}`}></Page>})}
						</Spread>)} 
					)}
         	</div>
         </div>
		);
	}
}
   